import { Link } from 'react-router-dom';

function CheckoutCancelPage() {
  return (
    <div style={{
      minHeight: '70vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🛒</div>
      <h1 style={{ color: '#f8fafc', marginBottom: '0.5rem' }}>Checkout Cancelled</h1>
      <p style={{ color: '#94a3b8', marginBottom: '2rem', maxWidth: '480px' }}>
        Your cart items are still saved. You can continue shopping or try again.
      </p>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <Link to="/marketplace" style={{
          padding: '0.7rem 1.5rem',
          borderRadius: '10px',
          background: 'linear-gradient(140deg, #3b82f6, #2563eb)',
          color: '#fff',
          fontWeight: 600,
          textDecoration: 'none',
        }}>
          Back to Marketplace
        </Link>
      </div>
    </div>
  );
}

export default CheckoutCancelPage;
